import { Theme, makeStyles } from '@material-ui/core'
import { dragIconColor, paginationSectionFontColor } from 'bpm/shared/bpmColors'

const iconStyles = {
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 3,
}

export const tableBodyStyles = makeStyles((theme: Theme) => ({
    rowContainer: {
        borderBottom: `1px solid ${dragIconColor}`,
        padding: '0 !important', // override bootstrap padding
        '& .sticky-left': {
            margin: 'unset !important',
            display: 'flex !important',
            alignItems: 'center',
            boxShadow: '8px 0px 8px rgba(0, 0, 0, 0.10)',
        },
        '& .sticky-right': {
            margin: 'unset !important',
            display: 'block !important',
            alignItems: 'center',
            boxShadow: '-8px 0px 8px rgba(0, 0, 0, 0.10)',
        },
    },
    centerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 130,
    },
    grayText: {
        ...theme.typography.h1,
        color: theme.palette.grey[700],
    },
    iconFamily: {
        marginLeft: '16px !important',
    },
    paginationContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        padding: 10,
        alignItems: 'center',
        border: `1px solid #c9c9c9`,
        position: 'sticky',
        top: 40,
        background: 'white',
        zIndex: 1,
        width: '100%',
    },
    paginationButton: {
        borderRadius: theme.spacing(2.5),
        color: '#04325B',
        padding: theme.spacing(1),
        height: 32,
    },
    buttonLabel: {
        lineHeight: '16px',
        '& .MuiButton-endIcon': {
           ...iconStyles,
           marginLeft: 2,
        },
        '& .MuiButton-startIcon': {
            ...iconStyles,
            marginRight: 2,
        },
    },
    arrowIcon: {
        color: '#314959',
    },
    paginationRecordsSpan: {
        borderRight: `1px solid ${paginationSectionFontColor}`,
        color: `${paginationSectionFontColor}`,
    },
}))
